export default __webpack_public_path__ + "media/transfer-bubble/arrow-803cd2bb.svg";